// Supabase (PostgREST) silently caps any query at 1000 rows. Tables like
// `submissions` are past that, so full-table fetches must page with .range().
// Pass a builder that returns a fresh query (a query can only be awaited once).
// Drop-in variant returning Supabase's { data, error } shape.
export async function selectAll(buildQuery, pageSize = 1000) {
  try {
    return { data: await fetchAllRows(buildQuery, pageSize), error: null };
  } catch (error) {
    return { data: null, error };
  }
}

export async function fetchAllRows(buildQuery, pageSize = 1000) {
  const all = [];
  for (let from = 0; ; from += pageSize) {
    const { data, error } = await buildQuery().range(from, from + pageSize - 1);
    if (error) throw error;
    all.push(...(data || []));
    if (!data || data.length < pageSize) return all;
  }
}
